import l10n from "@src/v3.0.0/lib/l10n";

/**
 * CONTAINER_MAX_WIDTH
 * @var {number} CONTAINER_MAX_WIDTH Container width relative to window.innerWidth
 */
export const CONTAINER_MAX_WIDTH = 0.88;

 /**
  * CONTAINER_MAX_HEIGHT
  * @var {number} CONTAINER_MAX_HEIGHT Container height relative to window.innerHeight
  */
export const CONTAINER_MAX_HEIGHT = 1;
 
 /**
  * CONTAINER_PAD
  * @var {number} CONTAINER_PAD Container inner padding (pcentage) relative to container size
  */
export const CONTAINER_PAD = 0.9;

/**
 * CROPPER_FRAME_PADDING_PCT
 * @var {number} CROPPER_FRAME_PADDING_PCT 
 * Padding laterale del container in percentuale (base 1)
 */
export const CROPPER_FRAME_PADDING_PCT = 0.9;

/**
 * CROPPER_FRAME_PADDING_PX
 * @var {number} CROPPER_FRAME_PADDING_PX Magic number / container padding in pixel
 */
export const CROPPER_FRAME_PADDING_PX = 45;

/**
 * CROPPER_FRAME_OFFSET_TOP_PX
 * @var {number} CROPPER_FRAME_OFFSET_TOP_PX 
 * Magic number / offset del frame (crop) applicato come sottrazione
 * (getCenter -> top -= CROPPER_FRAME_OFFSET_TOP_PX)
 */
export const CROPPER_FRAME_OFFSET_TOP_PX = 25;

export const CONTAINER_PAD_Y = 0.9;
export const CONTAINER_PAD_X = 0.9;

/**
 * ZOOM_WHEEL_STEP
 * @var {number} ZOOM_WHEEL_STEP Cropperjs zoom ratio
 */
export const ZOOM_WHEEL_STEP = 0.01;

/**
 * ZOOM_MAX_RATIO
 * @var {float} ZOOM_MAX_RATIO Max zoom ratio - double the product sizes
 */
export const ZOOM_MAX_RATIO = parseFloat(l10n.wppr_zoom_max_ratio) || Infinity;

/**
 * ZOOM_WARN_RATIO
 * @var {float} ZOOM_WARN_RATIO Max zoom ratio - double the product sizes
 */
export const ZOOM_WARN_RATIO = parseFloat(l10n.wppr_zoom_warn_ratio) || Infinity;

/**
 * DOM_RULER_SIZE
 * @var {number} DOM_RULER_SIZE Ruler size in cm
 */
export const DOM_RULER_SIZE = 50;

/**
 * MIN_WALL_SIZE
 * @var {number} MIN_WALL_SIZE Minimum wall size [cm]
 */
export const MIN_WALL_SIZE = parseFloat(l10n.wppr_wall_min_size) || 10;

/**
 * PRINT_REPEATS
 * @var {number} PRINT_REPEATS Times the print is repeated horizontally
 */
export const PRINT_REPEATS = 3;

/**
 * MAX_REPEATS
 * @var {number} MAX_REPEATS Max print ripeats times
 */
export const MAX_REPEATS = parseInt(l10n.wppr_max_repeats) || 9;

/**
 * HISTORY_MAX_UNDOS
 * @var {number} HISTORY_MAX_UNDOS Max times history undos
 */
export const HISTORY_MAX_UNDOS = 99;